import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import { AnalysisListItem } from './AnalysisList';

export function useAnalysisNavigation(chartList: AnalysisListItem[], path: string) {
  const params = useParams();
  const history = useHistory();
  const selectedAnalysisId: string | undefined = (params as any).selectedAnalaysisId;
  const getAnalysisUrl = (analysisId: string): string => `${path}/${analysisId}`;

  const setSelectedAnalysisId = (nextAnalysisId: string) => history.push(getAnalysisUrl(nextAnalysisId));

  if (selectedAnalysisId === undefined) {
    setSelectedAnalysisId(chartList[0].downloadId)
  }

  // Paging
  // First page = 0
  const totalPages = chartList.length;
  const [page, setPage] = useState(-1);
  useEffect(() => {
    const index = chartList.findIndex((c) => c.downloadId === selectedAnalysisId);
    setPage(index);
  }, [selectedAnalysisId]);

  // Can go next
  const nextChart = chartList.slice(page + 1).find((c) => !c.disabled);
  const canGoNext = !!nextChart;

  const handleGoToNext = () => setSelectedAnalysisId(nextChart?.downloadId ?? '');

  // Can go prev
  const prevChart = chartList
    .slice(0, page)
    .reverse()
    .find((c) => !c.disabled);

  const canGoPrev = !!prevChart;

  const handleGoToPrev = () => setSelectedAnalysisId(prevChart?.downloadId ?? '');

  // Keypresses
  useEffect(() => {
    const fn = (event: KeyboardEvent) => {
      if (event.altKey && event.key === 'ArrowRight' && canGoNext) {
        handleGoToNext();
      }
      if (event.altKey && event.key === 'ArrowLeft' && canGoPrev) {
        handleGoToPrev();
      }
    };
    document.addEventListener('keydown', fn);
    return () => {
      document.removeEventListener('keydown', fn);
    };
  }, [totalPages, page]);

  return {
    handleGoToNext,
    handleGoToPrev,
    canGoNext,
    canGoPrev,
    page,
    totalPages,
    setPage,
    selectedAnalysisId,
    setSelectedAnalysisId,
    getAnalysisUrl,
  };
}
